import script from "./ManageCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageCampaign.vue?vue&type=script&setup=true&lang=js"

import "./ManageCampaign.vue?vue&type=style&index=0&id=2c255f0d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c255f0d"]])

export default __exports__